module.exports = function () {
    return function (input) {
        if (input === undefined || input === null) {
            return input;
        }
        input = input || '';
        return input.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };

};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/bws-title-case.js
 **/